/* NoviTech — interacciones propias (vanilla, sin librerías) */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal(root) {
    var els = (root || document).querySelectorAll('.cp-reveal:not(.cp-visible)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('cp-visible'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('cp-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function initCountUp(root) {
    var els = (root || document).querySelectorAll('[data-cp-count]');
    if (!els.length) return;
    function run(el) {
      var target = parseFloat(el.getAttribute('data-cp-count')) || 0;
      var prefix = el.getAttribute('data-prefix') || '';
      var suffix = el.getAttribute('data-suffix') || '';
      if (reduce) { el.textContent = prefix + target + suffix; return; }
      var start = null, dur = 1400;
      function step(t) {
        if (!start) start = t;
        var p = Math.min((t - start) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = prefix + Math.round(target * eased) + suffix;
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }
    if (!('IntersectionObserver' in window)) { els.forEach(run); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { run(e.target); io.unobserve(e.target); } });
    }, { threshold: 0.5 });
    els.forEach(function (el) { io.observe(el); });
  }

  function initParallax() {
    var els = document.querySelectorAll('[data-cp-parallax]');
    if (!els.length || reduce) return;
    var ticking = false;
    function update() {
      els.forEach(function (el) {
        var k = parseFloat(el.getAttribute('data-cp-parallax')) || 0;
        var r = el.getBoundingClientRect();
        var off = (r.top - window.innerHeight * 0.3) * -k / 100;
        el.style.transform = 'translate3d(0,' + off.toFixed(1) + 'px,0) scale(' + (1 + Math.max(0, -r.top) * 0.00012 * k).toFixed(4) + ')';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    update();
  }

  function initSticky() {
    document.querySelectorAll('.cp-sticky').forEach(function (sec) {
      var items = sec.querySelectorAll('.cp-feature');
      if (!items.length || !('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            items.forEach(function (i) { i.classList.remove('cp-active'); });
            e.target.classList.add('cp-active');
          }
        });
      }, { rootMargin: '-45% 0px -45% 0px' });
      items.forEach(function (i) { io.observe(i); });
      items[0].classList.add('cp-active');
    });
  }

  function initGallery() {
    document.querySelectorAll('[data-cp-gallery]').forEach(function (g) {
      var main = g.querySelector('.cp-gallery__main img');
      var thumbs = g.querySelectorAll('.cp-gallery__thumb');
      if (!main || !thumbs.length) return;
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          thumbs.forEach(function (x) { x.classList.remove('is-active'); });
          t.classList.add('is-active');
          main.style.opacity = '0';
          setTimeout(function () {
            main.src = t.getAttribute('data-src');
            main.srcset = '';
            main.alt = t.getAttribute('data-alt') || '';
            main.style.opacity = '1';
          }, 180);
        });
      });
    });
  }

  function initVariants() {
    document.querySelectorAll('[data-cp-product]').forEach(function (box) {
      var dataEl = box.querySelector('script[data-cp-variants]');
      if (!dataEl) return;
      var variants = JSON.parse(dataEl.textContent);
      var idInput = box.querySelector('input[name="id"]');
      var btn = box.querySelector('[data-cp-add]');
      var priceNow = box.querySelector('[data-cp-price]');
      var priceWas = box.querySelector('[data-cp-compare]');
      var status = box.querySelector('[data-cp-status]');
      var fmt = box.getAttribute('data-money-format') || '${{amount}}';
      function money(cents) {
        var v = (cents / 100).toFixed(2);
        var withComma = v.replace('.', ',');
        return fmt.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withComma)
                  .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
                  .replace(/\{\{\s*amount\s*\}\}/, v.replace(/\B(?=(\d{3})+(?!\d))/g, ','));
      }
      function onChange() {
        var chosen = [];
        box.querySelectorAll('.cp-opt').forEach(function (fs) {
          var c = fs.querySelector('input:checked');
          chosen.push(c ? c.value : null);
        });
        var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === chosen[i]; }); });
        if (!v) { btn.disabled = true; btn.textContent = btn.getAttribute('data-unavailable'); return; }
        idInput.value = v.id;
        if (priceNow) priceNow.textContent = box.getAttribute('data-soon') || money(v.price);
        if (priceWas) {
          if (v.compare_at_price && v.compare_at_price > v.price) { priceWas.textContent = money(v.compare_at_price); priceWas.hidden = false; }
          else priceWas.hidden = true;
        }
        btn.disabled = !v.available;
        btn.textContent = v.available ? btn.getAttribute('data-add') : btn.getAttribute('data-soldout');
        if (status) status.hidden = v.available;
        var stockEl = box.querySelector('[data-cp-stock]'); var invEl = box.querySelector('script[data-cp-inv]');
        if (stockEl) {
          var inv = invEl ? (JSON.parse(invEl.textContent)[v.id]) : 999;
          var lowmax = parseInt(stockEl.getAttribute('data-lowmax') || '0', 10);
          stockEl.classList.toggle('is-no', !v.available);
          stockEl.textContent = !v.available ? stockEl.getAttribute('data-out') : (inv < 999 && inv <= lowmax ? stockEl.getAttribute('data-low').replace('[n]', inv) : stockEl.getAttribute('data-in'));
        }
        var sp = document.querySelector('[data-cp-sticky-price]'); if (sp && priceNow) sp.textContent = priceNow.textContent;
        var sb = document.querySelector('[data-cp-sticky-btn]'); if (sb) { sb.disabled = !v.available; sb.textContent = btn.textContent; }
        var fm = v.featured_media && v.featured_media.preview_image && v.featured_media.preview_image.src;
        var sec = box.closest('.cp-pdp');
        var mainImg = sec && sec.querySelector('.cp-gallery__main img');
        if (fm && mainImg) {
          mainImg.srcset = '';
          mainImg.src = fm + (fm.indexOf('?') > -1 ? '&' : '?') + 'width=1800';
          sec.querySelectorAll('.cp-gallery__thumb').forEach(function (t) {
            t.classList.toggle('is-active', (t.getAttribute('data-src') || '').split('?')[0].split('/').pop() === fm.split('?')[0].split('/').pop());
          });
        }
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
      box.querySelectorAll('.cp-opt input').forEach(function (i) { i.addEventListener('change', onChange); });
    });
  }


  function initStickyATC() {
    var bar = document.querySelector('[data-cp-sticky-atc]');
    var main = document.querySelector('#cp-main-form [data-cp-add]');
    if (!bar || !main || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var show = !e.isIntersecting && e.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        document.documentElement.classList.toggle('cp-has-sticky', show);
      });
    });
    io.observe(main);
  }

  function initQuickView() {
    var dlg = document.querySelector('[data-cp-qv-dialog]');
    if (!dlg || typeof dlg.showModal !== 'function') return;
    var body = dlg.querySelector('[data-cp-qv-body]');
    var strEl = document.querySelector('script[data-cp-qv-strings]');
    var t = strEl ? JSON.parse(strEl.textContent) : { add: 'Add to Cart', buy: 'Buy Now', soldout: 'Sold out', view: 'View full details', money: '${{amount}}' };
    function money(c) { return t.money.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, (c / 100).toFixed(2)); }
    function esc(x) { var d = document.createElement('div'); d.textContent = x == null ? '' : String(x); return d.innerHTML; }
    function img(src, w) { return src ? src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w : ''; }
    document.addEventListener('click', function (ev) {
      var b = ev.target.closest('[data-cp-qv]');
      if (!b) return;
      ev.preventDefault();
      body.innerHTML = '<p class="cp-qv__loading">…</p>';
      dlg.showModal();
      fetch('/products/' + b.getAttribute('data-cp-qv') + '.js').then(function (r) { return r.json(); }).then(function (p) {
        var v = p.variants.find(function (x) { return x.available; }) || p.variants[0];
        var thumbs = p.images.slice(0, 5).map(function (src, i) { return '<button type="button" class="cp-qv__thumb' + (i === 0 ? ' is-active' : '') + '" data-src="' + img(src, 900) + '"><img src="' + img(src, 160) + '" alt=""></button>'; }).join('');
        var opts = p.variants.length > 1 ? '<select name="id" class="cp-pcard__select">' + p.variants.map(function (x) { return '<option value="' + x.id + '"' + (x.id === v.id ? ' selected' : '') + (x.available ? '' : ' disabled') + '>' + esc(x.title) + (x.available ? '' : ' – ' + esc(t.soldout)) + '</option>'; }).join('') + '</select>' : '<input type="hidden" name="id" value="' + v.id + '">';
        body.innerHTML =
          '<div class="cp-qv__grid"><div><div class="cp-qv__main"><img src="' + img(p.featured_image || p.images[0], 900) + '" alt="' + esc(p.title) + '"></div><div class="cp-qv__thumbs">' + thumbs + '</div></div>' +
          '<div class="cp-qv__info"><h2>' + esc(p.title) + '</h2><p class="cp-qv__price">' + money(v.price) + (v.compare_at_price > v.price ? ' <s>' + money(v.compare_at_price) + '</s>' : '') + '</p>' +
          '<form method="post" action="/cart/add" class="cp-pcard__form">' + opts +
          '<div class="cp-pcard__btns"><button class="cp-btn cp-btn--primary" type="submit" name="add"' + (p.available ? '' : ' disabled') + '>' + esc(p.available ? t.add : t.soldout) + '</button>' +
          (p.available ? '<button class="cp-btn cp-btn--ghost" type="submit" name="return_to" value="/checkout">' + esc(t.buy) + '</button>' : '') + '</div></form>' +
          '<a class="cp-link" href="' + p.url + '">' + esc(t.view) + '</a></div></div>';
        body.querySelectorAll('.cp-qv__thumb').forEach(function (th) {
          th.addEventListener('click', function () {
            body.querySelectorAll('.cp-qv__thumb').forEach(function (x) { x.classList.remove('is-active'); });
            th.classList.add('is-active'); body.querySelector('.cp-qv__main img').src = th.getAttribute('data-src');
          });
        });
      }).catch(function () { window.location.href = '/products/' + b.getAttribute('data-cp-qv'); });
    });
    dlg.addEventListener('click', function (e) { if (e.target === dlg || e.target.closest('[data-cp-qv-close]')) dlg.close(); });
  }

  function initAll() {
    initReveal(); initCountUp(); initParallax(); initSticky(); initGallery(); initVariants(); initStickyATC(); initQuickView();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  // Editor de Shopify: re-inicializar al añadir/editar secciones
  document.addEventListener('shopify:section:load', function (e) { initReveal(e.target); initCountUp(e.target); initSticky(); initGallery(); initVariants(); });
})();
